<template>
    <div>
        <AltaSimpatizanteSga v-if="teatro.sga"/>
        <template v-else-if="footer.tipo == 1">
            <LayoutSports/>
        </template>
        <template v-else-if="footer.tipo == 2">
            <LayoutTeatros/>
        </template>
    </div>
</template>

<script>
    import LayoutSports from './layouts/Sports';
    import LayoutTeatros from './layouts/Teatros';
    import AltaSimpatizanteSga from '@/modules/front/sga/membresia/views/AltaSimpatizanteSga.vue';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        components: {
            LayoutSports,
            LayoutTeatros,
            AltaSimpatizanteSga
        },
        created() {
            useHead('Simpatizantes');

            if(!this.footer.venta_simpatizantes) {
                this.$router.push({ name: 'front.home'});
            }
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>
